export default __webpack_public_path__ + "38e84c0dd4606d831a2ea8175903f6b1.png";